import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import router from './router'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    // salvo in localstorage
    auth: state.auth,
    clidata: state.clidata,
    order: state.order,
    cart: state.cart,
    lastupdate: state.lastupdate,
    cartcounter: state.cartcounter,
    ordercounter: state.ordercounter,
    carnet: state.carnet,
    config: state.config,
  }),
})

const initialState = () => ({
  snack: {},
  clidata: {},
  order: {},
  cart: [],
  alert: {},
  lastupdate: null,
  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage: 'img/sidebar-1.jpg',
  drawer: null,
  auth: null,
  cartcounter: 0,
  ordercounter: 0,
  carnet: null,
  authuser: {},
  config: {},
})
export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: initialState,

  getters: {
    isAuthenticated: function (state) {
        return (sessionStorage.getItem('logged') === 'true')
    },
    clidata: function (state) {
      return state.clidata
    },
    order: function (state) {
      return state.order || {}
    },
    cart: function (state) {
      return state.cart || []
    },
    auth: function (state) {
      return state.auth
    },
  },
  mutations: {
    SET_CARTCOUNTER (state, counter) {
      state.cartcounter = counter
    },
    SET_ORDERCOUNTER (state, counter) {
      state.ordercounter = counter
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    setSnack (state, showSnack) {
      state.snack = { ...showSnack }
    },
    setAlert (state, showAlert) {
      // show popup_id
      console.log('setAlert', showAlert)
      state.alert = { ...showAlert }
    },
    setLastUpdate (state) {
      state.lastupdate = Date.now()
    },
    storeAuthMutation: function (state, data) {
       // console.log('mutations storeAuthrmations')
        console.log(data.userinfo.user_name, ' <==>', state.order?.codice)
      if (data.userinfo.user_name !== state.order?.codice) {
        state.order = {}
        state.carnet = []
      }
      state.auth = { ...data }
      // console.log('adesso lo stato vale ', state.auth)
    },
    setCliData: function (state, data) {
      state.clidata = { ...data }
    },
    setOrder: function (state, data) {
      state.order = { ...data }
    },
    setCart: function (state, data) {
      state.cart = [...data]
    },
    storeConfig: function (state, config) {
      state.config = config
    },

    logoutMutation: function (state) {
      console.log('clear_auth')
      sessionStorage.clear()
       const initial = initialState()
       Object.keys(initial).forEach(key => { ['order', 'carnet'].includes(key) ? console.log('storemantain', key) : state[key] = initial[key] })
      router.go(0)
    },
    clearAuth: function (state) {
      console.log('clear_auth')
      if (state.auth !== undefined && state.auth !== null) {
        state.auth = {}
      }
    },
    setCarnet: function (state, data) {
      state.carnet = { ...data }
    },
  },
  actions: {
    storeAuth: function ({ commit }, data) {
      commit('storeAuthMutation', data)
    },
    logout: function ({ commit }) {
      commit('logoutMutation')
    },
    clear_auth: function ({ commit }) {
      commit('clearAuth')
    },
  },
})
